import ajax from './http'

const categoryServer = {
  // 请求分类列表
  categoryData() {
    return ajax({
      url: '/category/categoryList',
      type: 'get'
    })
  },
  // 根据点击的分类加载数据
  classifyLists(param) {
    return ajax({
      url: '/category/getGoodsByCategoty',
      type: 'get',
      params: param
    })
  },
  // 请求商品详情
  detailData(param) {
    return ajax({
      url: '/commodity/commodityInfo',
      type: 'get',
      params: param
    })
  },
}
export default categoryServer
